import React, { useState, useEffect } from "react";
import { useNavigate, Navigate, useLocation } from "react-router-dom";
import {Link, NavLink } from "react-router-dom";



import Chart from 'chart.js/auto';
//import Utils from '../chartjs/baseutils.js';
//var dateFormat = require('dateformat');
import colorLib from '@kurkle/color';
	

const RenderChartacquisitions = () => {
const navigate = useNavigate();
const resturl=sessionStorage.getItem("RESTURL");
let customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");


let chartHandle=null;

const DATA_COUNT = 7;

//const labels = Utils.months({count: 7});
const labels = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July'
];
const data = {
  labels: labels,
  datasets: [
    {
      label: '2025/2026',
      data: [4,3,8,8,7,1,6],
      borderColor: 'rgb(255, 99, 132)',
       backgroundColor: transparentize('rgb(255, 99, 132)', 0.5),
	  
    },
    {
      label: '2026/2027',
      data: [8,7,1,6,4,3,8],
      borderColor: 'rgb(54, 162, 235)',
      backgroundColor: transparentize('rgb(54, 162, 235)', 0.5),
	  
    }
  ]
};



useEffect(() => {

const AD_USER=sessionStorage.getItem("AD_USER")??"";

if (AD_USER==""){
	navigate("/");
	return;
	}//end if
	
	
	
  chartHandle = new Chart(
    document.getElementById('acquisitions'),
    {
      type: 'bar',
      data: data
    }
  );	
	
	
	
	
	
 },[]);



function transparentize(value, opacity) {
  var alpha = opacity === undefined ? 0.5 : 1 - opacity;
  return colorLib(value).alpha(alpha).rgbString();
}


function destroyChart(){
	if (!chartHandle)
		return;
	chartHandle.destroy();
	
	
	  chartHandle = new Chart(
    document.getElementById('acquisitions'),
    {
      type: 'bar',
      data: data
    }
  );	
	
}//end if

  return (
    <>
	
	
	
	 <div style={{width:"800px"}} ><canvas id="acquisitions"></canvas></div>

<button className="button" onClick={(e)=>{destroyChart();}} >destroy</button>

    </>
  );
  


};


export default RenderChartacquisitions;